// extracted by mini-css-extract-plugin
module.exports = {"canvas":"styles_canvas__S_7Go","instructions":"styles_instructions__YA50z","fadeOut":"styles_fadeOut__X3uFL","highScore":"styles_highScore__l4YQ8","score":"styles_score___Azko"};